import BillsStore from "./Bills/Bills.Store";
import { RootStore } from "stores/index";
import { RouteType } from "types/RouteType";

const purchasesRoute: RouteType = {
  name: "Bills",
  path: "/accounting/bills",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Bills",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Purchases.Header"),
    },
    body: {
      component: () => import("./Purchases.Body"),
      grayBackground: true,
    },
  },
  group: 'Accounting',
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  // permissionPath: "accounting.purchases",
  enableAutoFind: false,
  // channels: [":tab"],
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const billsStore = rootStore.billsViewStore as BillsStore;
    await billsStore.loadBills();
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const billsStore = rootStore.billsViewStore as BillsStore;
    await billsStore.loadBills();
  },
  dialogs: [
    {
      name: "addBill",
      title: "Add Bill",
      component: () => import("./PurchasesDialogs/AddBillDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const billsStore = rootStore.billsViewStore as BillsStore;
        await billsStore.saveBill();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const billsStore = rootStore.billsViewStore as BillsStore;
        const formData = billsStore.formData;
        // Return true if validation fails (to disable submit button)
        return (
          !formData.billNumber ||
          !formData.billDate ||
          !formData.dueDate
        );
      },
      cancelButton: true,
      height: 800,
    },
    {
      name: "billDetails",
      title: "Bill Details",
      component: () => import("./PurchasesDialogs/BillDetailsDialog.Body"),
      cancelButton: true,
      height: 700,
    },
  ],
};

export default purchasesRoute;
